/**
 * 结算页
 */
export default [
  //当天挂号、预约取号支付
  {
    path: '/today-pay',
    component: () => import('../pages/pay/today-pay')
  },
  // 图文咨询和科室咨询支付
  {
    path: '/consult-pay/:id',
    component: () => import('../pages/pay/consult-pay')
  },
  // 体检预约支付
  {
    path: '/tijian-pay',
    component: () => import('../pages/pay/tijian-pay.vue')
  },
  {
    path: '/clinical-pay/:id',
    component: () => import('../pages/pay/clinical-pay.vue')
  },
  // 处方检查未支付处方支付
  {
    path: '/invoice-pay',
    component: () => import('../pages/pay/invoice-pay.vue')
  },
  // 慢病续方支付
  {
    path: '/renewal-pay',
    component: () => import('../pages/pay/renewal-pay.vue')
  },
  //病例邮寄支付页
  {
    path: '/common-pay',
    component: () => import('../pages/pay/common-pay.vue')
  },
  //网络诊间支付页
  {
    path: '/online-pay',
    component: () => import('../pages/pay/online-pay.vue')
  },
  //网约护士支付页
  {
    path: '/nurse-pay',
    component: () => import('../pages/pay/nurse-pay.vue')
  },
  /**
   * 缴纳预缴金
   */
  {
    path: '/manager/payment',
    name: 'manager-payment',
    component: () => import('../pages/pay/payment')
  },
  // 处方送药到家支付
  {
    path: '/recipe-pay',
    component: () => import('../pages/pay/recipe-pay.vue')
  },
]



// WEBPACK FOOTER //
// ./src/router/pay.js